import { writable, derived } from 'svelte/store';
const browser = typeof window !== 'undefined';

// Using local API endpoints instead of direct API access
const API_BASE_URL = '/api/proxy';

// Create persistent store helper
function createPersistedStore(name, initialValue) {
  const storedValue = browser ? localStorage.getItem(name) : null;
  const initial = storedValue ? JSON.parse(storedValue) : initialValue;
  
  const store = writable(initial);
  
  if (browser) {
    store.subscribe(value => {
      if (value !== undefined) {
        localStorage.setItem(name, JSON.stringify(value));
      }
    });
  }
  
  return store;
}

// Base config
const baseConfig = {
  delayHoursDefault: parseInt(import.meta.env.VITE_DELAY_HOURS_DEFAULT || '0'),
  delayVisible: import.meta.env.VITE_DELAY_VISIBLE === 'true'
};

// Simplified config store - removed userConfig dependency
export const config = writable({
  ...baseConfig
});

